import { useCallback, useEffect, useState } from 'react';
import { getProfile } from '../api/ProfileAPI';
import { useSocket } from '../socket/SocketContext';

// status: 'loading' | 'ok' | 'notfound' | 'error'. reload() after an action
// (add/remove friend...) so the card shows the new relationship.
export function useProfileData(username, { full = false } = {}) {
  const [state, setState] = useState({ status: 'loading', profile: null });

  const load = useCallback(async () => {
    const res = await getProfile(username, { full }).catch(() => ({ status: 'fail' }));
    if (res.status === 'success') setState({ status: 'ok', profile: res.profile });
    else setState((prev) => ({ status: res.message === 'User not found.' ? 'notfound' : 'error', profile: prev.profile }));
  }, [username, full]);

  useEffect(() => {
    setState({ status: 'loading', profile: null });
    load();
  }, [load]);

  // The person edited their profile (or an admin reset it) while it's open
  // - refetch quietly, keeping what's shown until the new one arrives.
  const { socket, connected } = useSocket();
  useEffect(() => {
    const s = socket && socket.current;
    if (!s) return undefined;
    const onUpdated = (payload) => { if (payload && payload.username === username) load(); };
    s.on('profile:updated', onUpdated);
    return () => s.off('profile:updated', onUpdated);
  }, [socket, connected, username, load]);

  return { ...state, reload: load };
}
